import React, { useEffect, useState } from "react";
import { paginate } from "../../utils/paginate";
import ProductCard from "../Card/ProductCard";
import Pagination from "../Common/Pagination";
import SecTitle from "../Common/SecTitle";
import { getProducts } from "../../services/ProductService";
const Products = () => {
  const [isActive, setIsActive] = useState(false);
  const [ProSelected, setProSelected] = useState({});
  const [perPage, setPerPage] = useState(8);
  const [currentPage, setCurrentPage] = useState(1);
  const [products, setProducts] = useState(1);

  useEffect(() => {
    GetAllProducts();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedCourses = paginate(products, currentPage, perPage);
  console.log("paginatedCourses", paginatedCourses);

  const GetAllProducts = async () => {
    try {
      const data = await getProducts();
      if (data.data.State == true) {
        setProducts(data.data.Data);
      } else {
      }
    } catch (ex) {}
  };
  const LoadProductData = (event, id) => {
    const product_copy = [...products];
    const selected_index = product_copy.findIndex((p) => p.id === id);
    const selected_product = product_copy[selected_index];
    setProSelected(selected_product);
    if (!isActive) {
      setIsActive((current) => !current);
    }
  };
  const closeBtnClicked = () => {
    setIsActive(false);
  };

  return (
    <section className="product_sec">
      <div className="container">
        <SecTitle title="محصولات" />

        <div className="row">
          {products.length !== 0
            ? paginatedCourses.map((item) => (
                <div key={item.id} className="col-lg-3 col-md-4 col-sm-6">
                  <ProductCard
                    LoadData={LoadProductData}
                    isActive={isActive}
                    data={item}
                  />
                </div>
              ))
            : ""}
        </div>
        <Pagination
          totlal={products.length}
          currentPage={currentPage}
          perPage={perPage}
          onPageChange={handlePageChange}
        />
      </div>
      <div
        className={
          isActive
            ? "product_details product_details_open"
            : "product_details product_details_close"
        }
      >
        <a onClick={closeBtnClicked} className="close_btn">
          <i className="fa fa-close fa-2x text-white"></i>
        </a>
        <img src="/images/company2.jpg" alt="" className="img-fluid" />
        <div className="mt-3 bg-white h-100 m-2 mt-3 py-4 rounded-3">
          <h4 className="text-center fw-bold">{ProSelected.title}</h4>
          <p className="px-3 mt-2" style={{ overflowY: "auto" }}>
            {ProSelected._desc}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Products;
